import { Button } from "./button";

export class MenuItem
{
    constructor(public name?: string, public callback?: () => boolean | void, public submenu?: MenuItem[], public iconClass?: string, public buttons?: Button[], public mobileCallbackMenuItem?: MenuItem, public iconNgStyle: object = {}, public clickChangeIcon:boolean=false, public enabledIcon:string="",  public disabledIcon:string="")
    {

    }
}